<template>
  <div class="Table4Charts">
    <DateDropDownSelect
      v-if="value.isShowRightDropDownBox"
      :selectData="selectData"
      :selectApi="selectApi"
      @selectChange="tabSelectChange"
    >
    </DateDropDownSelect>
    <div class="power-data">
      <table style="width: 100%; table-layout: fixed" border="0" cellspacing="0" class="table">
        <thead>
          <tr>
            <th
              :style="{
                fontSize: `${fontStyle.xAxisSize}px`,
                padding: `${$w_Ratio(16, $store)}px`,
              }"
              v-for="item in tableProps"
              :key="item"
              scope="col"
            >
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr-line" v-for="(tab, rowIndex) in tableData" :key="tab">
            <td
              v-for="(h, colIndex) in tableProps"
              :key="`${rowIndex}-${colIndex}`"
              :style="{
                fontSize: `${fontStyle.yAxisSize}px`,
                padding: `${$w_Ratio(14, $store)}px`,
              }"
            >
              <span
                :class="{
                  'ranked-cell': RankingColor.isShow && colIndex === 0,
                  'rank-1': RankingColor.isShow && colIndex === 0 && rowIndex === 0,
                  'rank-2': RankingColor.isShow && colIndex === 0 && rowIndex === 1,
                  'rank-3': RankingColor.isShow && colIndex === 0 && rowIndex >= 2,
                }"
              >
                {{ tab[h] }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { table } from 'bootstrap';
import { request } from '../../../../common/request';
import { getFilterValue } from '../../../../utils/tool';
import DateDropDownSelect from '@/components/common/DateDropDownSelect/DateDropDownSelect.vue';

export default {
  name: 'Table4Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  components: { DateDropDownSelect },

  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      value: {
        isShowRightDropDownBox: false,
      },
      tabselectData: [], // 下拉选择的时间数据d
      selectData: [],
      params: {}, // 请求参数
      paramsCopy: {},
      noData: false, // 无数据
      tabShow: true,
      fontStyle: {},
      loading: true,
      // 表格数据
      tableData: [
        {
          id: '1',
          name: '任重道远',
          age: '22',
        },
        {
          id: '2',
          name: '木叶下',
          age: '21',
        },
        {
          id: '3',
          name: '郭德纲',
          age: '47',
        },
      ],
      selectApi: '',
      tableProps: ['景点名称', '接待人数', '景区舒适度', '承载量'], // 表格属性
      // 表格跳转数据
      value: {
        isShowRightDropDownBox: false,
      },
      RankingColor: {
        isShow: false,
      },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    // this.getApiDataResByFilterAndResponseQuery();

    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    console.log(params, 'params params');
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    tabSelectChange(e) {
      // 判断是否使用静态数据
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
      } else {
        this.params = this.getFilterValue(e);
        console.log(this.params, '252424242423');
        this.startApiIntervalTask();
      }
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    cloumnWith(index, item) {
      if (item.prop === 'time' && index == 0) {
        return 100;
      }
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let color = [];
      let source = [];
      let seriesList = [];
      let tableDownData = [];

      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      let tableProps = [];
      let dropDownNumberData = [];
      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        color = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;

        seriesList = ParamData.seriesList;
        // tableProps = ParamData?.tableProps; // 表格数据需要的
        tableDownData = ParamData?.tableDownData; // 表格数据需要的
        dropDownNumberData = ParamData?.dropDownNumberData;
      }
      console.log(dropDownNumberData, 'dropDownNumberData');

      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
        this.fontStyle = fontStyle;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }
      if (this.Configuration.propertyData?.RankingTableColor?.value) {
        this.RankingColor = this.Configuration.propertyData.RankingTableColor.value;
      }

      // 时间
      let that = this;
      function dealSelectData() {
        let tabselectData = [];
        let pickerType = [];
        let selectData = [];
        let yearData = [];
        let monthData = [];

        if (dropDownNumberData) {
          dropDownNumberData.forEach(Years => {
            let child = [];
            let choicekey = [];
            // 子 一月 二月... 判断
            if (Years[3]) {
              Years[3].forEach(item_D => {
                //  判断 是否有出现 展示第3个下拉框的标识
                if (item_D[2] != undefined && item_D[2] != null) {
                  child.push({
                    label: item_D[0],
                    value: item_D[1],
                    // 需要出现 日 时
                    third: item_D[2],
                  });
                } else {
                  child.push({
                    label: item_D[0],
                    value: item_D[1],
                  });
                }
              });
            }

            if (Years[4]) {
              choicekey.push(Years[4]);
            }

            // 父 不为空
            if (Years[0] != undefined && child.length != 0 && Years[4]) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
                children: child,
                key: choicekey,
              });
            } else if (Years[0] != undefined && child.length != 0) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
                children: child,
              });
            } else if (Years[0] != undefined) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
              });
            }
          });
        }
        if (tableDownData) {
          tableDownData.forEach(item_t => {
            tabselectData.push(
              item_t[0], //  tabMont  tabYear
            );
            pickerType.push(item_t[1]);
          });
        }
        that.selectData = selectData;
      }
      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }

      let props = []; // 表格遍历需要的prop以及对应的name
      let tableData = []; // 数据
      let keys = [];
      let tempMap = {};
      function DealData() {
        let orderList = []; // 用于记录原始顺序
        source.forEach(item => {
          const { s, x, y } = item;
          if (!tempMap[s]) {
            tempMap[s] = {};
            orderList.push(s); // 记录第一次出现的顺序
          }

          tempMap[s][x] = y;
        });

        // 按原始顺序处理，而不是用 for...in
        orderList.forEach(key => {
          tableData.push(tempMap[key]);
        });
      }
      DealData();
      keys = Object.keys(tableData[0]);

      this.tableData = tableData;
      this.tableProps = keys;

      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
        // console.log('关闭加载', this.loading.close);
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            // this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        // console.log(ChartsData.staticData);
        this.$nextTick(() => {
          // this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除定时器
      clearInterval(this.apiIntervalTaskID);
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          let dataSet = {};

          eval(filter_text);

          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '样式表格',
    componentName: 'Table4Charts',
    componentOverViewImg: './img/charts/TableCharts/Table4Charts.png',
    id: '',
    style: {
      width: 400,
      height: 200,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
          },
          staticData: {
            seriesList: ['1', '2', '3'],
            source: [
              {
                s: '1',
                x: '上报区域',
                y: '区域1',
              },
              {
                s: '1',
                x: '上报时间',
                y: '2024-10-6',
              },
              {
                s: '1',
                x: '上报内容',
                y: '内容111',
              },

              {
                s: '2',
                x: '上报区域',
                y: '区域2',
              },
              {
                s: '2',
                x: '上报时间',
                y: '2024-10-7',
              },
              {
                s: '2',
                x: '上报内容',
                y: '内容222',
              },

              {
                s: '3',
                x: '上报区域',
                y: '区域3',
              },
              {
                s: '3',
                x: '上报时间',
                y: '2024-10-8',
              },
              {
                s: '3',
                x: '上报内容',
                y: '内容333',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 10,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '5%',
          bottom: '17%',
          top: '12%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
      RankingTableColor: {
        propertyComponentName: 'RankingTableColorConfiger',
        value: {
          isShow: false,
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.Table4Charts {
  color: white;
  width: 100%;
  height: 100%;
  .power-data {
    height: auto;
    max-height: 100%;
    overflow: scroll;
  }
  .table {
    font-family: 'SimHei', '黑体';
    /* font-weight: bold; */
    border-collapse: separate;
    border-spacing: 0 6px;
  }
  .table tbody tr.tr-line {
    position: relative; /* 必需，以便伪元素能够相对于tr定位 */
  }
  .table tbody tr.tr-line:hover {
    background-color: rgb(37, 46, 66);
  }

  thead tr th {
    background-color: #286891;
    color: #fff;

    text-align: center;
  }
  tbody tr td {
    padding: 6px 8px;
    color: #fff;
    background-color: #0a2b57;
    text-align: center;
  }
  .no-data {
    width: 100%;
    height: 100%;
    // background: #000;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }
  :deep().el-loading-spinner {
    .path {
      stroke: #fff !important;
    }

    p {
      display: flex !important;
      align-items: center !important;
      color: #fff !important;
    }
  }
  .row_user_url {
    color: #08e5ed;
    text-decoration: none;
  }
  .DateDropDownSelect {
    position: absolute !important;
    right: 10px !important;
    top: 6px !important;
    z-index: 10 !important;
  }
}
.ranked-cell {
  border-radius: 4px 8px 8px 4px;
  padding: 4px;
  text-align: center;
  width: 30%;
}
/* 排名颜色样式 */
.rank-1 {
  background-image: linear-gradient(to right, #f44336, #f443362f);
}

.rank-2 {
  background-image: linear-gradient(to right, #b9a71c, #b9a71c2f);
}

.rank-3 {
  background-image: linear-gradient(to right, #3572e7, #3572e72f);
  /* background-color: #3572e7; */
  /* 蓝色 */
}
::v-deep .el-table__body {
  //-webkit-border-horizontal-spacing: 4px;
  /* // 水平间距 */
  -webkit-border-vertical-spacing: 4px;
  /* 垂直间距 */
  tr:hover > td {
    background-color: #1d2a4ea3 !important;
  }
}
:deep().el-table--border td,
.el-table--border th {
  border-right: none;
  padding: 4px 0;
  color: #c5c7d1;
  background: #212a3eb5;
}
/* // 滚动条的宽度 */
:deep() .el-table__body-wrapper::-webkit-scrollbar {
  /* // 横向滚动条 */
  width: 6px;
  /* // 纵向滚动条 必写 */
  height: 4px;
}
/* // 滚动条的滑块 */
:deep() .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #8f8f8fd3;
  border-radius: 3px;
}

::-webkit-scrollbar {
  width: 0px;
  height: 2px;
  background-color: none;
}
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #5ec7da75;
  border-radius: 3px;
}
@media screen and (max-width: 800px) {
  ::v-deep.el-table {
    th.gutter colgroup.gutter {
      display: block !important;
      width: 6px !important;
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-table__body-wrapper {
    overflow-x: scroll !important;
    overflow-y: hidden !important;
  }
}
@media screen and (min-width: 3300px) {
  :deep().el-table--border th,
  .el-table--border td {
    line-height: 3 !important;
    font-size: 24px !important;
  }
  :deep().el-table--border td,
  .el-table--border th {
    padding: 14px 0 !important;
    font-size: 24px !important;
  }
}
</style>
